module.exports = __webpack_public_path__ + "img/down.f7e6bbba.svg";